// Pure display helper for the job-cost profitability panel (Session ABU Part D). Turns the
// labour-cost figure into the office-facing text, distinguishing the two reasons it cannot be
// computed so the office knows which field to fill in:
//   - no on-site times recorded  -> "No time recorded"   (the engineer's job to record)
//   - no engineer cost rate set   -> "Cost rate not set"  (the office sets it on the Engineers page)
// When both are present the actual money figure is shown. No React/DOM dependency so it unit tests.
import type { JobProfitability } from "./api";

export function labourCostDisplay(p: Pick<JobProfitability, "labourCostReason" | "labourCostPence">): string {
  if (p.labourCostReason === "no_time") return "No time recorded";
  if (p.labourCostReason === "no_rate") return "Cost rate not set";
  return p.labourCostPence == null ? "Not recorded" : `£${(p.labourCostPence / 100).toFixed(2)}`;
}
